
import React from 'react';
import Layout from '@/components/Layout/Layout';
import AutoCalculator from '@/components/SpecialCalculators/FinancialCalculators/AutoCalculator';
import { Link } from 'react-router-dom';

const AutoCalculatorPage = () => {
  return (
    <Layout>
      <div className="max-w-5xl mx-auto px-4">
        {/* Header Section */}
        <div className="mb-8">
          <div className="text-sm text-gray-500 mb-2">
            <Link to="/" className="hover:underline">Home</Link> {' > '} 
            <Link to="/special" className="hover:underline">Special Tools</Link> {' > '} 
            <span>Auto Loan Calculator</span>
          </div>
          <h1 className="text-3xl font-bold mb-3">Auto Loan Calculator</h1>
          <p className="text-gray-700">
            Calculate your monthly car payments, determine total interest, and understand the true cost of your auto loan.
          </p>
        </div>

        {/* Calculator Section */}
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 mb-8">
          <AutoCalculator />
        </div>

        {/* Information Section */}
        <div className="bg-[#E6F3FF] p-6 rounded-lg mb-8">
          <h2 className="text-2xl font-semibold mb-3">How to use the Auto Loan Calculator</h2>
          <ol className="list-decimal list-inside space-y-2 text-gray-700 ml-2">
            <li>Enter the car price</li>
            <li>Enter your down payment amount</li>
            <li>Specify the loan term in months (typically 36, 48, 60, or 72 months)</li>
            <li>Enter the interest rate offered by your lender</li>
            <li>The calculator will show your monthly payment, total interest, and total cost of the vehicle</li>
          </ol>
        </div>

        {/* Additional Information */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-3">About Auto Loans</h2>
          <p className="text-gray-700 mb-3">
            An auto loan is a secured loan that helps you finance the purchase of a vehicle. The vehicle itself serves as collateral 
            for the loan. Auto loans typically have terms ranging from 36 to 72 months, with longer terms resulting in lower monthly 
            payments but higher total interest costs.
          </p>
          <p className="text-gray-700 mb-3">
            The interest rate on your auto loan is influenced by several factors, including your credit score, the loan term, 
            the age of the vehicle, and current market conditions. Generally, new cars qualify for lower interest rates than used cars, 
            and borrowers with higher credit scores receive more favorable rates.
          </p>
          <p className="text-gray-700 mb-3">
            When budgeting for a car purchase, remember to account for additional costs beyond the monthly loan payment, 
            such as insurance, registration, maintenance, and fuel.
          </p>
        </div>

        {/* Related Calculators */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-3">Related Calculators</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            <Link to="/special/loan" className="p-4 border border-gray-200 rounded-md hover:bg-gray-50 flex items-center">
              <span className="text-xl mr-2">💰</span> Loan Calculator
            </Link>
            <Link to="/special/mortgage" className="p-4 border border-gray-200 rounded-md hover:bg-gray-50 flex items-center">
              <span className="text-xl mr-2">🏠</span> Mortgage Calculator
            </Link>
            <Link to="/special/investment" className="p-4 border border-gray-200 rounded-md hover:bg-gray-50 flex items-center">
              <span className="text-xl mr-2">📈</span> Investment Calculator
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AutoCalculatorPage;
